import { render, staticRenderFns } from "./kanbanflow.vue?vue&type=template&id=43e11aa5&scoped=true"
import script from "./kanbanflow.vue?vue&type=script&lang=ts"
export * from "./kanbanflow.vue?vue&type=script&lang=ts"
import style0 from "./kanbanflow.vue?vue&type=style&index=0&id=43e11aa5&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "43e11aa5",
  null
  
)

export default component.exports